import { twMerge } from 'tailwind-merge';
import Card from '@/components/Card';
import Tooltip from '@/components/Tooltip';
import Title from '@/components/Title';
import { RocketIcon, WarningIcon } from '@/icons';
import { formatNumber, formatPercentage, renderPrice } from '@/utils/strings';
import { classes } from '../utils';

export type ProfitLossCardProps = {
  className?: string;
  companyCount: number;
  missingCompanyCount: number;
  profitLoss: {
    deltaPrice: number;
    deltaPercent: number;
  };
};

export default function ProfitLossCard({
  className,
  companyCount,
  missingCompanyCount,
  profitLoss,
}: ProfitLossCardProps) {
  const renderProfitLossTitle = () => {
    const isMissingMultiple = missingCompanyCount > 1;
    const { deltaPrice, deltaPercent } = profitLoss;
    return (
      <div className={classes.textWrapper}>
        <div className={classes.label}>
          Profit/Loss
          {isMissingMultiple && (
            <Tooltip
              className={classes.warning}
              title={`${formatNumber(missingCompanyCount)} ${isMissingMultiple ? 'companies are' : 'company is'} missing valuation data`}>
              <WarningIcon className={classes.warningIcon} />
            </Tooltip>
          )}
        </div>
        <Title size="md">
          {missingCompanyCount === companyCount ? (
            '--'
          ) : (
            <>
              <span className={classes.price}>
                {renderPrice(deltaPrice, { concise: true })}
              </span>
              {!isNaN(deltaPercent) && (
                <span
                  className={twMerge(
                    classes.percentage,
                    deltaPercent > 0 ? classes.positive : classes.negative
                  )}>
                  ({formatPercentage(deltaPercent, 1)})
                </span>
              )}
            </>
          )}
        </Title>
      </div>
    );
  };

  return (
    <Card className={twMerge(classes.card, className)}>
      {renderProfitLossTitle()}
      <div className={twMerge(classes.icon, classes.rocketIcon)}>
        <RocketIcon />
      </div>
    </Card>
  );
}
